import React, { Component } from "react";
import TopBanner from "./TopBanner";
import Content from "./Content";
import BottomBanner from "./BottomBanner";
import "./App.css";

class App extends Component {
  render() {
    return (
      <div className="App">
        <TopBanner />
        <Content />
        <BottomBanner />
        <div className="Overlay" />
      </div>
    );
  }
}

export default App;
